<template>
  <div class="page-content--body with-submenu profile-search">
    <div class="page-content--body-left information-menu">
      <v-card max-width="320" outlined class="page-content--body-nav">
        <v-card-text>
          <div class="auth-form--wrap-col">
            <div class="input-label">Город</div>
            <v-autocomplete
              v-model="form.city_id"
              :items="cities"
              :search-input.sync="searchCity"
              :loading="loading"
              :filter="() => true"
              :clearable="true"
              :open-on-clear="true"
              hide-details
              hide-no-data
              class="plcolor custom-autocomplete"
              item-text="title"
              item-value="id"
              dense
              solo
            />
          </div>
          <div class="profile-search--checkbox">
            <div class="profile-search--checkbox-title">Тип исполнителя</div>
            <v-checkbox
              label="Монтажник"
              color="primary"
              value="primary"
              hide-details
            ></v-checkbox>
            <v-checkbox
              label="Монтажник с ИП"
              color="primary"
              value="primary"
              hide-details
            ></v-checkbox>
            <v-checkbox
              label="Монтажная организация"
              color="primary"
              value="primary"
              hide-details
            ></v-checkbox>
          </div>
          <div class="profile-search--checkbox">
            <div class="profile-search--checkbox-title">Специализация</div>
            <v-checkbox
              label="Водяной теплый пол"
              color="primary"
              value="primary"
              hide-details
            ></v-checkbox>
            <v-checkbox
              label="Водоснабжение"
              color="primary"
              value="primary"
              hide-details
            ></v-checkbox>
            <v-checkbox
              label="Автоматика"
              color="primary"
              value="primary"
              hide-details
            ></v-checkbox>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <div class="page-content--body-right profile-worker">
      <v-card outlined>
        <v-card-text>
          <div class="profile-worker--info">
            <div class="profile-worker--info-data">
              <div class="profile-worker--info-data-photo">
                <img src="@/assets/images/user-photo.jpg" alt="">
              </div>
              <div class="profile-worker--info-data-wrap">
                <div class="profile-worker--info-data-name">Антонова Екатерина</div>
                <div class="profile-worker--info-data-rating">
                  <v-rating
                    v-model="rating"
                    background-color="orange lighten-3"
                    color="orange"
                    readonly
                    size="16"
                  ></v-rating>
                </div>
                <div class="profile-worker--info-data-city">
                  Россия, Пермский край, г Пермь
                </div>
                <div class="profile-worker--info-data-experience">
                  <div class="ico-info"><img src="@/assets/images/ico-user-info1.svg" alt=""></div>
                  Опыт с технологиями REHAU: более 5 лет
                </div>
                <div class="profile-worker--info-data-legal">
                  <div class="ico-info"><img src="@/assets/images/ico-user-info2.svg" alt=""></div>
                  Монтажник с юридическим лицом
                </div>
                <router-link to="" class="profile-worker--info-data-link">Профиль</router-link>
              </div>
            </div>
            <div class="profile-worker--info-types">
              <div class="profile-worker--info-types-objects">
                <div class="object-types--title">Типы объектов:</div>
                <div class="object-types--icons">
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type01.svg" alt="">
                      </template>
                      <span>Маляр</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type02.svg" alt="">
                      </template>
                      <span>Штукатур</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type03.svg" alt="">
                      </template>
                      <span>Усач</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type04.svg" alt="">
                      </template>
                      <span>Мозг</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type05.svg" alt="">
                      </template>
                      <span>База данных</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
              <div class="profile-worker--info-types-objects">
                <div class="object-types--title">Специализации:</div>
                <div class="object-types--icons">
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type01.svg" alt="">
                      </template>
                      <span>Маляр</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type02.svg" alt="">
                      </template>
                      <span>Штукатур</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type03.svg" alt="">
                      </template>
                      <span>Усач</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type04.svg" alt="">
                      </template>
                      <span>Мозг</span>
                    </v-tooltip>
                  </div>
                  <div class="object-types--icons-icon">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" src="@/assets/images/ico-object-type05.svg" alt="">
                      </template>
                      <span>База данных</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <div class="profile-worker--info-button">
              <v-btn icon class="more-btn">
                <img src="@/assets/images/ico-points.svg" alt="">
              </v-btn>
            </div>
          </div>
        </v-card-text>

        <v-card-text class="profile-worker--footer">
          <v-rating
            v-model="ratingHeart"
            full-icon="mdi-heart"
            empty-icon="mdi-heart-outline"
            half-icon="$mdi-heart-half-full"
            color="#E93535"
            background-color="grey"
            size="20"
          ></v-rating>
          <v-btn class="btn-small btn-blue" color="primary">Отправить заявку</v-btn>
        </v-card-text>
      </v-card>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Page9',
  data() {
    return {
      rating: 5,
      ratingHeart: 3,
      cities: [],
      searchCity: '',
      form: {
        city_id: null,
      },
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  watch: {
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
  },
};
</script>

<style lang="scss" src="./style.scss"/>
